/** Cloud Run API used for production builds when REACT_APP_API_URL is missing. */
export const PRODUCTION_API_URL =
  'https://picra-server-187337178119.us-east4.run.app';

/**
 * Resolve the API base URL.
 * Never fall back to localhost in a production bundle — that breaks Amplify/hosted clients.
 */
export function getApiBaseUrl() {
  const fromEnv = (process.env.REACT_APP_API_URL || '').trim();
  if (fromEnv && !/^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?\/?$/i.test(fromEnv)) {
    return fromEnv.replace(/\/$/, '');
  }
  if (process.env.NODE_ENV === 'production') {
    return PRODUCTION_API_URL;
  }
  return fromEnv || 'http://localhost:5000';
}
